<template>
    <div>
        <el-card shadow="hover">
            <div>
                <template style="float: left;">
                    <el-button type="primary" size="small" icon="el-icon-document-add" v-has="'PlatAdmin'" @click="doAdd()">添加</el-button>
                    <el-button type="success" size="small" icon="el-icon-document-copy" v-has="'PlatAdmin'" @click="doBatchAdd()">批量添加</el-button>
                    <el-button-group style="margin-left:20px;" v-show="selRows.length > 0">
                        <el-tooltip effect="dark" content="删除" placement="top">
                            <el-button size="small" icon="el-icon-delete" @click="doDelete()"></el-button>
                        </el-tooltip>
                    </el-button-group>
                </template>
                <el-form style="float: right" inline :model="query" size="small">
                    <div @keydown.enter="doQuery()">
                        <el-form-item>
                            <el-input v-model="query.name" clearable placeholder="考点名称" style="width:150px;"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-input v-model="query.room" clearable placeholder="考场名称" style="width:150px;"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-tooltip effect="dark" content="查询" placement="top">
                                <el-button type="warning" size="small" icon="el-icon-search" circle @click="doQuery"></el-button>
                            </el-tooltip>
                        </el-form-item>
                        <el-form-item>
                            <el-tooltip effect="dark" content="清空查询条件" placement="top">
                                <el-button size="small" icon="el-icon-refresh" circle @click="doReset"></el-button>
                            </el-tooltip>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
        </el-card>
        <!--Table-->
        <el-card shadow="hover" style="margin-top: 10px;">
            <el-table ref="table" v-loading="tableLoading" :data="datas" highlight-current-row :border="true" stripe tooltip-effect="dark" @selection-change="doSelectionChange" style="width: 100%">
                <el-table-column type="selection" width="40" />
                <el-table-column show-overflow-tooltip label="考场名称" width="100">
                    <template slot-scope="scope">
                        <span>{{ scope.row.room }}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="考点名称" width="200">
                    <template slot-scope="scope">
                        <span>{{ scope.row.name }}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="考点地址" width="250">
                    <template slot-scope="scope">
                        <span>{{ scope.row.addr }}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="考试时间" width="250">
                    <template slot-scope="scope">
                        <span>{{ scope.row.times }}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="考点序号" width="250">
                    <template slot-scope="scope">
                        <span>{{ scope.row.ano }}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="考场序号" width="250">
                    <template slot-scope="scope">
                        <span>{{ scope.row.rno }}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="考试类别" width="250">
                    <template slot-scope="scope">
                        <span>{{ scope.row.cata }}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="监考人员">
                    <template slot-scope="scope">
                        <el-tag style="margin-right: 10px;" :key="pu.id" v-for="pu in scope.row.pus">{{ pu.name }} [{{ pu.key }}]</el-tag>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="最大人数" width="100">
                    <template slot-scope="scope">
                        <span>{{ scope.row.max }}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="索引值" width="100">
                    <template slot-scope="scope">
                        <span>{{ scope.row.sort }}</span>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" width="100" label="操作">
                    <template slot-scope="scope">
                        <el-button size="mini" icon="el-icon-edit" v-has="'PlatAdmin'" @click.stop="doEdit(scope.row)">
                            编辑
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        <el-card shadow="hover" v-show="this.data.pages > 1" style="margin-top: 10px;">
            <el-pagination
                background
                @current-change="doChangePage"
                @size-change="doChangeSize"
                :current-page="this.data.page"
                :page-sizes="[10, 30, 50, 100]"
                :page-size="this.query.size"
                layout="-> ,total,  prev, pager, next, jumper, sizes"
                :total="this.data.rows"
            />
        </el-card>
        <!--Form-->
        <el-dialog title="详情" :visible.sync="formDialog" :close-on-click-modal="false" :close-on-press-escape="false" fullscreen append-to-body>
            <el-form ref="venuesForm" :model="field" :rules="rules" label-position="top">
                <el-row :gutter="10">
                    <el-col :span="6">
                        <el-row :gutter="10">
                            <el-col :span="12">
                                <el-form-item label="考点名称" prop="name">
                                    <el-input v-model="field.name" placeholder="请填写考点名称"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="考点序号" prop="ano">
                                    <el-input v-model="field.ano" placeholder="请填写考点序号" min="0" max="9" maxlength="1"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="10">
                            <el-col :span="12">
                                <el-form-item label="考场名称" prop="room">
                                    <el-input v-model="field.room" placeholder="请填写考场名称"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="考场序号" prop="rno">
                                    <el-input v-model="field.rno" placeholder="请填写考场序号" maxlength="3"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="10">
                            <el-col :span="12">
                                <el-form-item label="考试类别" prop="cata">
                                    <el-input v-model="field.cata" placeholder="请填写考试类别"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="考试时间" prop="times">
                                    <el-date-picker style="width: 100%;" v-model="field.times" type="datetime" :editable="false" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择考试时间"></el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="最大人数" prop="max">
                                    <el-input v-model="field.max" type="number" placeholder="请填写最大人数"></el-input>
                                </el-form-item>
                            </el-col>

                            <el-col :span="12">
                                <el-form-item label="排序值" prop="sort">
                                    <el-input v-model="field.sort" type="number" placeholder="请填写排序值"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-form-item label="考点地址" prop="addr">
                            <el-input v-model="field.addr" placeholder="请填写考点地址"></el-input>
                        </el-form-item>
                        <el-form-item label="监考人员" prop="puids">
                            <el-select v-model="puidArr" multiple placeholder="请选择" style="width: 100%;">
                                <el-option v-for="item in pus" :key="item.id" :label="item.name" :value="item.id">
                                    <span style="float: left">{{ item.name }}</span>
                                    <span style="float: right; color: #8492a6; font-size: 0.8em;margin-right: 1.2em;">{{ item.key }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <div style="text-align: right;">
                            <el-button type="primary" :loading="submitLoading" size="medium" icon="el-icon-circle-check" @click="doSubmit">
                                保存
                            </el-button>
                            <el-button type="info" plain size="medium" icon="el-icon-switch-button" @click="formDialog = false">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="自定义座次表打印模板，留空则使用计划模板" prop="zcbt">
                            <codemirror v-model="field.zcbt" :options="{ tabSize: 2, mode: 'text/html', lineNumbers: true, lineWrapping: true }" class="codemirror"></codemirror>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="自定义座次表预览模板，留空则使用计划模板" prop="zcbp">
                            <codemirror v-model="field.zcbp" :options="{ tabSize: 2, mode: 'text/html', lineNumbers: true, lineWrapping: true }" class="codemirror"></codemirror>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="自定义座次表App查看模板，留空则使用计划模板" prop="zcba">
                            <codemirror v-model="field.zcba" :options="{ tabSize: 2, mode: 'text/html', lineNumbers: true, lineWrapping: true }" class="codemirror"></codemirror>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-dialog>
        <!--Form-->
        <el-dialog title="批量添加" :visible.sync="addDialog" :close-on-click-modal="false" :close-on-press-escape="false" fullscreen append-to-body>
            <el-form ref="addForm" :model="addField" :rules="addRules" label-position="top">
                <el-row :gutter="10">
                    <el-col :span="6">
                        <el-form-item label="考点名称" prop="name">
                            <el-input v-model="addField.name" placeholder="请填写考点名称"></el-input>
                        </el-form-item>
                        <el-row :gutter="10">
                            <el-col :span="12">
                                <el-form-item label="初始场次" prop="init">
                                    <el-input v-model="addField.init" type="number" placeholder="请填写初始场次"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="考点序号" prop="ano">
                                    <el-input v-model="addField.ano" type="number" placeholder="请填写考点序号"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-form-item label="考场数量" prop="num">
                            <el-input v-model="addField.num" type="number" placeholder="请填写考场数量"></el-input>
                        </el-form-item>
                        <el-form-item label="考试类别" prop="cata">
                            <el-input v-model="addField.cata" placeholder="请填写考试类别"></el-input>
                        </el-form-item>
                        <el-form-item label="考试时间" prop="times">
                            <el-date-picker style="width: 100%;" v-model="addField.times" type="datetime" :editable="false" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择考试时间"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="最大人数" prop="max">
                            <el-input v-model="addField.max" type="number" placeholder="请填写最大人数"></el-input>
                        </el-form-item>
                        <el-form-item label="考点地址" prop="addr">
                            <el-input v-model="addField.addr" placeholder="请填写考点地址"></el-input>
                        </el-form-item>
                        <el-form-item label="监考人员" prop="puids">
                            <el-select v-model="puidArr" multiple placeholder="请选择" style="width: 100%;">
                                <el-option v-for="item in pus" :key="item.id" :label="item.name" :value="item.id">
                                    <span style="float: left">{{ item.name }}</span>
                                    <span style="float: right; color: #8492a6; font-size: 0.8em;margin-right: 1.2em;">{{ item.key }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <div style="text-align: right;">
                            <el-button type="primary" :loading="submitLoading" size="medium" icon="el-icon-circle-check" @click="doSubmitAdd">
                                保存
                            </el-button>
                            <el-button type="info" plain size="medium" icon="el-icon-switch-button" @click="addDialog = false">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="自定义座次表打印模板，留空则使用计划模板" prop="zcbt">
                            <codemirror v-model="addField.zcbt" :options="{ tabSize: 2, mode: 'text/html', lineNumbers: true, lineWrapping: true }" class="codemirror"></codemirror>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="自定义座次表预览模板，留空则使用计划模板" prop="zcbp">
                            <codemirror v-model="addField.zcbp" :options="{ tabSize: 2, mode: 'text/html', lineNumbers: true, lineWrapping: true }" class="codemirror"></codemirror>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="自定义座次表App查看模板，留空则使用计划模板" prop="zcba">
                            <codemirror v-model="addField.zcba" :options="{ tabSize: 2, mode: 'text/html', lineNumbers: true, lineWrapping: true }" class="codemirror"></codemirror>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import { codemirror } from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import 'codemirror/mode/javascript/javascript.js'
import 'codemirror/mode/htmlmixed/htmlmixed.js'
import 'codemirror/mode/xml/xml.js'

export default {
    name: 'PlanVenues',
    props: {
        pid: {
            type: String,
            required: true
        }
    },
    components: {
        codemirror
    },
    data() {
        return {
            query: {
                page: 1,
                size: 10,
                time: 0,
                name: '',
                room: '',
                rno: ''
            },
            data: {
                rows: 0,
                pages: 0,
                page: 1,
                time: 0
            },
            tableLoading: false,
            datas: [],
            selRows: [],
            puidArr: [],
            pus: [],
            field: {
                id: '',
                name: '',
                room: '',
                rno: '',
                zcbt: '',
                zcbp: '',
                zcba: '',
                max: 0,
                sort: 0,
                ano: 0,
                addr: '',
                cata: '',
                times: '',
                puids: ''
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: '请填写考点名称',
                        trigger: 'blur'
                    }
                ],
                room: [
                    {
                        required: true,
                        message: '请填写考场名称',
                        trigger: 'blur'
                    }
                ],
                rno: [
                    {
                        required: true,
                        message: '请填写考场序号',
                        trigger: 'blur'
                    }
                ],
                addr: [
                    {
                        required: true,
                        message: '请填写考场地址',
                        trigger: 'blur'
                    }
                ],
                cata: [
                    {
                        required: true,
                        message: '请添加考试类别',
                        trigger: 'blur'
                    }
                ],
                times: [
                    {
                        required: true,
                        message: '请添加考试时间',
                        trigger: 'blur'
                    }
                ],
                max: [
                    {
                        required: true,
                        message: '请填写最大人数',
                        trigger: 'blur'
                    }
                ],
                ano: [
                    {
                        required: true,
                        message: '请填写考点序号',
                        trigger: 'blur'
                    }
                ],
                sort: [
                    {
                        required: true,
                        message: '请填写排序值',
                        trigger: 'blur'
                    }
                ]
            },
            addField: {
                name: '',
                init: 1,
                ano: '0',
                num: 1,
                zcbt: '',
                zcba: '',
                zcbp: '',
                max: 0,
                addr: '',
                cata: '',
                times: '',
                sort: 0,
                puids: ''
            },
            addRules: {
                name: [
                    {
                        required: true,
                        message: '请填写考点名称',
                        trigger: 'blur'
                    }
                ],
                init: [
                    {
                        required: true,
                        message: '请填写初始数量',
                        trigger: 'blur'
                    }
                ],
                ano: [
                    {
                        required: true,
                        message: '请填写考点序号初始值',
                        trigger: 'blur'
                    }
                ],
                num: [
                    {
                        required: true,
                        message: '请填写考场数量',
                        trigger: 'blur'
                    }
                ],
                addr: [
                    {
                        required: true,
                        message: '请填写考场地址',
                        trigger: 'blur'
                    }
                ],
                cata: [
                    {
                        required: true,
                        message: '请填写考试类别',
                        trigger: 'blur'
                    }
                ],
                times: [
                    {
                        required: true,
                        message: '请填写考试时间',
                        trigger: 'blur'
                    }
                ],
                max: [
                    {
                        required: true,
                        message: '请填写最大人数',
                        trigger: 'blur'
                    }
                ]
            },
            formDialog: false,
            addDialog: false,
            submitLoading: false
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        init() {
            this.doLoad()
        },
        doLoad() {
            this.tableLoading = true
            this.query.pid = this.pid
            this.$http
                .get('/ops/recruit/venues/list', {
                    params: this.query
                })
                .then(result => {
                    this.tableLoading = false
                    if (result.data.page === 1) {
                        this.query.time = result.data.time
                    }
                    this.data = result.data
                    this.datas = result.datas
                })
            this.$http.get('/comm/data/proctor/query').then(result => {
                this.pus = result.datas
            })
        },
        doQuery() {
            this.query.page = 1
            this.doLoad()
        },
        doReset() {
            this.query = {
                page: 1,
                size: 10,
                time: 0,
                name: '',
                room: '',
                rno: ''
            }
            this.doQuery()
        },
        doChangePage(num) {
            this.query.page = num
            this.doLoad()
        },
        doChangeSize(num) {
            this.query.page = 1
            this.query.size = num
            this.doLoad()
        },
        doSelectionChange(rows) {
            this.selRows = rows
        },

        clearFields() {
            this.field = {
                id: '',
                name: '',
                room: '',
                rno: '',
                zcbt: '',
                zcba: '',
                max: 0,
                sort: 0,
                ano: 0,
                addr: '',
                puids: ''
            }
            this.addField = {
                name: '',
                num: 1,
                zcbt: '',
                zcba: '',
                max: 0,
                addr: '',
                puids: ''
            }
            this.puidArr = []
            if (this.$refs['venuesForm']) {
                this.$refs['venuesForm'].resetFields()
                this.$refs['venuesForm'].clearValidate()
            }
            if (this.$refs['addForm']) {
                this.$refs['addForm'].resetFields()
                this.$refs['addForm'].clearValidate()
            }
        },
        doBatchAdd() {
            this.clearFields()
            this.addDialog = true
        },
        doSubmitAdd() {
            this.addField.puids = this.puidArr.join()
            this.$refs['addForm'].validate(valid => {
                if (valid) {
                    this.addField.pid = this.pid
                    this.submitLoading = true
                    this.$http.post('/ops/recruit/venues/add', this.addField).then(result => {
                        this.submitLoading = false
                        if (result.code === 0) {
                            this.doLoad()
                            this.addDialog = false
                            this.$message.success('添加成功')
                        }
                    })
                } else {
                    this.$message.error('请填写完整的信息')
                }
            })
        },
        doAdd() {
            this.clearFields()
            this.formDialog = true
        },
        doEdit(item) {
            this.clearFields()
            this.field = {
                ...item
            }
            this.puidArr = this.field.pus.map(pu => pu.id)
            this.formDialog = true
        },
        doSubmit() {
            this.field.puids = this.puidArr.join()
            this.$refs['venuesForm'].validate(valid => {
                if (valid) {
                    this.field.pid = this.pid
                    this.submitLoading = true
                    this.$http.post('/ops/recruit/venues/save', this.field).then(result => {
                        this.submitLoading = false
                        if (result.code === 0) {
                            this.doLoad()
                            this.formDialog = false
                            this.$message.success('保存成功')
                        }
                    })
                } else {
                    this.$message.error('请填写完整的信息')
                }
            })
        },
        doDelete(item) {
            let names = []
            let ids = []
            if (item) {
                names.push(item.name)
                ids.push(item.id)
            } else {
                this.selRows.forEach(row => {
                    names.push(row.name)
                    ids.push(row.id)
                })
            }
            if (ids.length === 0) {
                this.$message.error('请选择要删除的内容')
                return
            }
            this.$confirm('是否删除[' + names.join() + ']?删除后将无法恢复', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http
                    .post('/ops/recruit/venues/delete', {
                        ids: ids.join()
                    })
                    .then(result => {
                        if (result.code === 0) {
                            this.$message.success('删除成功')
                            this.doLoad()
                        }
                    })
            })
        }
    }
}
</script>
